<style scoped lang="scss">
.modal {
  z-index: 2001;
  .modal-body {
    overflow: visible;
  }
}
.agenda-online-controls__controls {
  @apply justify-center;
}
</style>

<template>
  <div
    v-if="active"
    v-scroll-lock="true"
    class="modal active"
  >
    <div class="modal-overlay" />

    <section class="modal-container appointment-simple agenda-online-controls">
      <header class="modal-header appointment-simple__header">
        <a
          class="btn btn-clear float-right appointment-simple__close"
          aria-label="close"
          @click="close"
        >
        </a>

        <h1 class="agenda-online-controls__title">
          {{ header }}
        </h1>
      </header>

      <article class="modal-body appointment-simple__body">
        <p class="agenda-online-controls__text">
          {{body}}
        </p>

        <div class="agenda-online-controls__controls">
          <textarea
            v-model="url"
            rows="4"
            readonly
            class="agenda-online-controls__input"
            onclick="this.focus();this.select();"
          />

          <div
            id="control-copy"
            class="agenda-online-controls__button"
            @mouseenter="ui.showCopy = true"
            @mouseleave="ui.showCopy = false"
            @click="copyText(url)"
          >
            <dr-icon
              color="rgb(86, 189, 210)"
              name="copy"
              class="agenda-online-controls__icon"
            />

            <transition name="fade">
              <div
                v-if="ui.showCopy"
                class="agenda-online-controls__tooltip"
              >
                {{ ui.copyText }}
              </div>
            </transition>
          </div>

          <div
            id="control-whatsapp"
            class="agenda-online-controls__button"
            @mouseenter="ui.showWhatsapp = true"
            @mouseleave="ui.showWhatsapp = false"
            @click="shareUrl"
          >
            <dr-icon
              color="rgb(86, 189, 210)"
              name="whatsapp"
              class="agenda-online-controls__icon"
            />

            <transition name="fade">
              <div
                v-if="ui.showWhatsapp"
                class="agenda-online-controls__tooltip"
              >
                Compartilhar no WhatsApp
              </div>
            </transition>
          </div>

        </div>
      </article>
    </section>
  </div>
</template>

<script>
export default {
  name: 'DrModalShareLink',

  props: {
    active: {
      required: true,
      type: Boolean,
      default: () => false
    },

    header: {
      type: String,
      default: null
    },

    body: {
      type: String,
      default: null
    },

    url: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      ui: {
        showLink: false,
        showCopy: false,
        showWhatsapp: false,
        showEmbeddableCode: false,
        copyText: 'Copiar link',
        copyCode: 'Copiar código'
      },
      observer: null
    }
  },

  watch: {
    'ui.showCopy': {
      deep: false,
      immediate: false,
      handler (v) {
        if (!v) {
          this.ui.copyText = 'Copiar link'
        }
      }
    },

    active: {
      deep: false,
      immediate: true,
      handler (v) {
        if (this.observer) {
          this.observer.disconnect()
        }

        if (v) {
          this.createObserver()
        }
      }
    }
  },

  computed: {
    whatsappMessage () {
      return `Olá, veja o link para a videochamada: ${this.url}`
    }
  },

  methods: {
    close () {
      this.$emit('close')
    },

    copyText (what, control = 'link') {
      navigator.clipboard
        .writeText(what)
        .then(() => {
          if (control === 'link') {
            this.ui.copyText = 'Copiado!'
          } else {
            this.ui.copyCode = 'Código copiado!'
          }
        })
        .catch(() => {
          if (control === 'link') {
            this.ui.copyText = 'Erro :('
          } else {
            this.ui.copyCode = 'Erro :('
          }
        })
    },

    shareUrl () {
      window.open(`https://web.whatsapp.com/send?text=${this.whatsappMessage}`, '_blank')
    },

    openLink () {
      window.open(this.url, '_blank')
    },

    createObserver () {
      this.$nextTick(() => {
        const controlCopy = document.querySelector('#control-copy')
        const controlWhatsapp = document.querySelector('#control-whatsapp')

        const config = { attributes: false, childList: true, subtree: true }

        this.observer = new MutationObserver(this.setTooltipPosition)

        this.observer.observe(controlCopy, config)
        this.observer.observe(controlWhatsapp, config)
      })
    },

    setTooltipPosition (mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const tooltip = mutation.target.querySelector('.agenda-online-controls__tooltip') || null
          if (tooltip) {
            const { top, left } = mutation.target.getBoundingClientRect()
            const height = mutation.target.offsetHeight

            tooltip.style.top = `${top - height}px`
            tooltip.style.left = `${left}px`
          }
        }
      }
    }
  }
}
</script>
